import AchieveImg from "../assets/img/achieve-img.png";
import AchieveImg2 from "../assets/img/achieve-img2.png";
import AchieveImg3 from "../assets/img/achieve-img3.png";
import AchieveImg4 from "../assets/img/achieve-img4.png";
import AchieveImg5 from "../assets/img/achieve-img5.png";
import AchieveImg6 from "../assets/img/achieve-img6.png";
import AchieveImg7 from "../assets/img/achieve-img6.png";
import AchieveImg8 from "../assets/img/achieve-img8.png";

export const dummyAchieves = [
  {
    id: 1,
    title: "Неделя с 7тренировками",
    img: AchieveImg,
  },
  {
    id: 2,
    title: "Идеальная неделя упражнений",
    img: AchieveImg2,
  },
  {
    id: 3,
    title: "Рекорд в беге на 5 км",
    img: AchieveImg3,
  },
  {
    id: 4,
    title: "Бег на 10 км",
    img: AchieveImg4,
  },
  {
    id: 5,
    title: "Первая тренировка по ходьбе",
    img: AchieveImg5,
  },
  {
    id: 6,
    title: "Новый рекорд упражнений",
    img: AchieveImg6,
  },
  {
    id: 7,
    title: "25 целей и достижений",
    img: AchieveImg7,
  },
  {
    id: 8,
    title: "Рекорд беговых тренировок",
    img: AchieveImg8,
  },
];
